define('webshopCategoriesListHeaderToolsView',[
  'module',
  'settings',
  'underscore',
  'buttonView',
  'modalsAlertView',
  'modalView',
  'tableHeaderFieldView',
  'webshopCategoriesDetailView',
  'webshopCategoryAddView',
  'template!webshopCategoriesListHeaderToolsView'
], function (
  Module,
  Settings,
  _,
  ButtonView,
  AlertView,
  ModalView,
  FieldView,
  DetailView,
  AddView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-categories-header-tools-view ' + FieldView.prototype.className,

    regions: {
      addRegion: '.add-region'
    },

    onRender: function() {     
      this.addButtonView = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('categories.createNew'),
        title: _.i18n('categories.createNew')
      });

      this.addRegion.show(this.addButtonView);
      this.addButtonView.on('click', _.bind(this.onAdd, this));
    },

    onAdd: function() {
      ModalView.prototype.open({
        childView: AddView,              
        confirmButtonText: _.i18n('category.add.modal.confirm-button'),
        title: _.i18n('categories.createNew'),       
        onConfirm: _.bind(function (model) {   
          var data = {
          };

          $.ajax({
            type: 'POST',
            url: Settings.url('compuzz2', 'webshop/category/add', {
              code: model.get('code'),
              parentId: model.get('parentId')
            }),
            processData: false,
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: _.bind(function (data) {
              this.tableView.reload();
              this.tableView.footerView.fetch();

              if(data && data.category)
                DetailView.prototype.open(data.category.id);
            }, this),
            error: _.bind(function (jqXHR) {
              var message = '';
              if(jqXHR.responseJSON && jqXHR.responseJSON.message)
                message = jqXHR.responseJSON.message;
              AlertView.prototype.open('', _.i18n('categories.add.error.message').replace('%s', message));
            }, this)
          });  
        }, this),
        onCancel: _.bind(function () {                  
        }, this)
      });        
    }
  });
});
